import { Badge, Box, Flex, HStack, IconButton, SimpleGrid, Stack, Stat, StatNumber, Text } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import { fetchCompany, fetchDeliveries, fetchDrivers, fetchFleets, fetchVehicles, getUser } from '../../store/actions';
import { useAppDispatch, useAppSelector } from '../../hooks';

import { AppDispatch } from '../../store';
import { BsTruck } from 'react-icons/bs';
// import { Link as DefaultLink } from 'react-router-dom';
import { GiMoneyStack } from 'react-icons/gi';
import { GrRefresh } from 'react-icons/gr';
import MapView from './components/MapView';
import { TableView } from './components';
import { ToastContainer } from 'react-toastify';
import { deliveryType } from '../../types';

// import { io } from 'socket.io-client';

export const ViewDeliveries = () => {

    // const socket = io('http://localhost:8003/');

    const [isOpen, setDeleteDialog] = useState<boolean>(false);

    const [statuses] = useState<Array<string>>(['await approval', 'approved', 'upcoming', 'active', 'delivered', 'cancelled']);

    //eslint-disable-next-line
    const [view, setView] = useState<string>('table');

    const { deliveries, is_loading_deliveries } = useAppSelector(state => state.deliveryReducer);
    const { customers } = useAppSelector(state => state.customersReducer);
    const { users } = useAppSelector(state => state.usersReducer);

    const { drivers, vehicles } = useAppSelector(state => state.vehicleReducer);

    const dispatch: AppDispatch = useAppDispatch();

    const handleRefresh = () => {
        dispatch(fetchDeliveries());
    };

    const filterByStatus = (status: string) => {
        const _deliveries = deliveries.filter((delivery: deliveryType) => delivery.status === status);
        return _deliveries;
    };

    const getTotal = deliveries?.filter((delivery: any) => delivery.status === 'delivered').reduce((previousValue: any, currentValue: any) => previousValue + currentValue.total, 0);

    useEffect(() => {
        dispatch(getUser());
        dispatch(fetchDeliveries());
        dispatch(fetchDrivers());
        dispatch(fetchVehicles());
        dispatch(fetchCompany());
        dispatch(fetchFleets());
        // return () => {
        //     socket.on('connect', () => {
        //         console.log(socket.id);
        //     });
        // };
    }, []);

    return (
        <>
            <Flex
                minH={'-webkit-fill-available'}
                align={'center'}
                justify={'center'}
                pt={2}
                pb={10}
            >
                <Stack>
                    <Stack mb={6}>
                        <SimpleGrid columns={[1, null, 3]} spacing='40px'>
                            <Box w='100%'>
                                <HStack bg={'#FFFFFF'} p={4} borderRadius={6}>
                                    <Stack p={6} bg='#e8f5e9' borderRadius={'50%'} mr={2}>
                                        <GiMoneyStack color="#388e3c" style={{ width: '40px', height: '40px' }} />
                                    </Stack>
                                    <Stat>
                                        <Badge minW={'80px'} colorScheme={'green'} px={2} borderRadius={3}>Delivered total</Badge>
                                        <StatNumber>R{getTotal.toFixed(2) || 0}</StatNumber>

                                    </Stat>
                                </HStack>
                            </Box>
                            <Box w='100%'>
                                <HStack bg={'#FFFFFF'} p={4} borderRadius={6}>
                                    <Stack p={6} bg='#f5f5f5' borderRadius={'50%'} mr={2}>
                                        <BsTruck style={{ width: '40px', height: '40px' }} />
                                    </Stack>
                                    <Stat>
                                        <Badge minW={'80px'} bg={'#ffecb3'} color={'#212121'} px={2} borderRadius={3}>await approval</Badge>
                                        <StatNumber>{filterByStatus('await approval').length || 0}</StatNumber>
                                    </Stat>
                                </HStack>
                            </Box>
                            <Box w='100%'>
                                <HStack bg={'#FFFFFF'} p={4} borderRadius={6}>
                                    <Stack p={6} bg='#f5f5f5' borderRadius={'50%'} mr={2}>
                                        <BsTruck style={{ width: '40px', height: '40px' }} />
                                    </Stack>
                                    <Stat>
                                        <Badge minW={'80px'} colorScheme={'gray'} px={2} borderRadius={3}>approved</Badge>
                                        <StatNumber>{filterByStatus('approved').length || 0}</StatNumber>
                                    </Stat>
                                </HStack>
                            </Box>
                        </SimpleGrid>
                    </Stack>
                    <Stack bg={'#FFFFFF'} p={4} borderRadius={6}>
                        <HStack justifyContent={'space-between'} mb={4} px={2}>
                            <Text textTransform={'capitalize'} fontSize={20} fontWeight={'medium'}>Deliveries {view}</Text>
                            <HStack>
                                <IconButton aria-label='Refresh button' size={'sm'} icon={<GrRefresh className={is_loading_deliveries ? 'loading-refresh-icon' : ''} />} onClick={handleRefresh} />
                                {/* <ButtonGroup size={'sm'} isAttached variant='outline'>
                                    <IconButton colorScheme={view === 'table' ? 'yellow' : 'gray'} onClick={() => setView('table')} aria-label='table view' icon={<AiOutlineTable />} />
                                    <IconButton colorScheme={view === 'map' ? 'yellow' : 'gray'} onClick={() => setView('map')} aria-label='map view' icon={<GrMapLocation />} />
                                </ButtonGroup> */}
                                {/* <Button colorScheme={'yellow'} size='sm' as={DefaultLink} to='/deliveries/add'>
                                    New Delivery
                                </Button> */}
                            </HStack>
                        </HStack>
                        {
                            view === 'table' ?
                                <TableView
                                    deliveries={deliveries}
                                    customers={customers}
                                    drivers={drivers}
                                    statuses={statuses}
                                    isOpen={isOpen}
                                    vehicles={vehicles}
                                    users={users}
                                    setDeleteDialog={setDeleteDialog}
                                />
                                :
                                <MapView />
                        }
                    </Stack>
                </Stack>
                <ToastContainer />
            </Flex>
        </>
    );
};